import { makeCygnusApiCall } from "api/api";

/**
 * Fetches all worksheets.
 */
export const getAllWorksheetsData = async (selectedReturnId: string): Promise<any> => {
  const allWorksheets = await makeCygnusApiCall({
    type: "POST",
    payload: { SelectedReturn: selectedReturnId },
    url: `/worksheets/all/`,
    show_message: false,
    customized_success_message: "Fetched Worksheets Data Successfully",
    customized_failure_message: "Unable to fetch Worksheets data, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true
  })

  if(allWorksheets) {
    return { 
      data: allWorksheets?.data
    }  
  }
  return [];
}

/**
 * Downloads selected files as a merged pdf.
 * @param {object} payload - all documents data of client.
 */
export const exportToPDF = async (payload: any): Promise<any> => {
  const exportToPDFResponse = await makeCygnusApiCall({
    type: "POST",
    payload: payload,
    url: `/export_to_pdf/`,
    show_message: true,
    customized_success_message: "PBC Documents Data Successfully Exported to PDF",
    customized_failure_message: "Unable to export PBC documents data to PDF, please contact support and attach a screenshot.",
    isblob: true,
    path: "/tax",
    istax: true
  })

  return exportToPDFResponse ?? false;
}



/**
 * Imports all the client PBC documents data to tax.
 * @param {object} payload - all documents data of client.
 */
export const exportToExcel = async (payload: any): Promise<any> => {
  const exportToExcelResponse = await makeCygnusApiCall({
    type: "POST",
    payload: payload,
    url: `/export_to_excel/`,
    show_message: true,
    customized_success_message: "PBC Documents Data Successfully Exported to Excel",
    customized_failure_message: "Unable to export PBC documents data to Excel, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true,
    default_message: true
  })

  return exportToExcelResponse ?? false;
}

/**
 * @param {string} worksheetId - The ID of the document fetch data for.
 * Fetches the client documents in form of blob to download based on form responsedataid.
 */
export const downloadWorksheet = async (worksheetId: any): Promise<Blob> => {
  const document = await makeCygnusApiCall({
    type: "GET",
    payload: {},
    url: `/worksheets/download/${worksheetId}/`,
    show_message: true,
    customized_success_message: "Downloaded Worksheet Successfully",
    customized_failure_message: "Unable to fetch worksheet data, please contact support and attach a screenshot.",
    isblob: true,
    path: "/tax",
    istax: true
  });

  return document ?? null;
}